import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feet-wash',
  templateUrl: './feet-wash.component.html',
  styleUrls: ['./feet-wash.component.css']
})
export class FeetWashComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
